// Tiny event-emitter-backed toast bus. The <ToastContainer /> mounted in
// Layout.tsx subscribes; pages call `toast.success(msg)` / `toast.error(msg)`
// from anywhere without prop drilling or context.

export type ToastVariant = 'success' | 'error';

export interface ToastItem {
  id: number;
  variant: ToastVariant;
  message: string;
}

type Listener = (t: ToastItem) => void;

const listeners = new Set<Listener>();
let nextId = 1;

function emit(variant: ToastVariant, message: string) {
  const item: ToastItem = { id: nextId++, variant, message };
  for (const l of listeners) l(item);
}

export function subscribeToToasts(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export const toast = {
  success(message: string) {
    emit('success', message);
  },
  error(message: string) {
    emit('error', message);
  },
};
